import { Navigate, useLocation } from 'react-router-dom';
import { useUserStore } from '@/store/user-store';

interface PrivateRouteProps {
  children: React.ReactNode;
}

/**
 * PrivateRoute wrapper component
 * Redirects unauthenticated users to sign-in page with redirectTo param
 */
export function PrivateRoute({ children }: PrivateRouteProps) {
  const { isAuthenticated, _hasHydrated } = useUserStore();
  const location = useLocation();

  // Wait for Zustand to hydrate before checking auth
  if (!_hasHydrated) {
    return null;
  }

  if (!isAuthenticated) {
    // Redirect to sign-in with current path as redirectTo
    const redirectTo = encodeURIComponent(location.pathname + location.search);
    return <Navigate to={`/auth/signin?redirectTo=${redirectTo}`} replace />;
  }

  return <>{children}</>;
}
